import { BASE_URL } from '../../constants/api';
import Fetch from '../fetch';
import Store from '../../stores/Store';

import CacheService from '../../utils/CacheService';

import { LookUpType, SummaryType, SummaryItemType } from '../../types/types';

async function getAllLoopUp() {
  const store = new Store();
  const token = store.get('token');

  const url = `${BASE_URL}/api/lookup/getAllLookup?token=${token}`;

  const json = await CacheService(
    'lookup/getAllLookup',
    async () => {
      const json: LookUpType[] = await Fetch(url, {
        method: 'POST',
        headers: {
          'x-token': store.get('x-token'),
          'x-csrf': store.get('x-csrf'),
          accept: 'application/json',
        },
        body: JSON.stringify({}),
      });

      const lookup: SummaryType = json.reduce(
        (accu, iter: SummaryItemType) => {
          accu[iter.category].push(iter);

          return accu;
        },
        {
          ANNUAL_INCOME: [],
          BENEFICIARY_TYPE: [],
          CITIZENSHIP: [],
          EDUCATION_BACKGROUND: [],
          GENDER: [],
          ID_TYPE: [],
          INVESTMENT_PURPOSE: [],
          MARITAL_STATUS: [],
          NATURE_OF_BUSINESS: [],
          OCCUPATION: [],
          REFERRAL: [],
          RELIGION: [],
          SALUTATION: [],
          SOURCE_OF_INCOME: [],
          TYPE_OF_ACCOUNT: [],
        }
      );

      return lookup;
    },
    {
      expiry: 60 * 40,
    }
  );

  return json;
}

export async function getOptions({
  category,
  param,
}: {
  category?: string;
  param?: string;
}) {
  const response = await getAllLoopUp();
  return category ? response[category] || [] : response;
}
